import { useState, useCallback, useEffect } from "react";

interface Challenge {
  question: string;
  answer: number;
}

function generateChallenge(): Challenge {
  const a = Math.floor(Math.random() * 10) + 1;
  const b = Math.floor(Math.random() * 10) + 1;
  return { question: `${a} + ${b}`, answer: a + b };
}

export function useHumanCheck() {
  const [challenge, setChallenge] = useState<Challenge>(generateChallenge);
  const [userAnswer, setUserAnswer] = useState("");
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState("");

  const refresh = useCallback(() => {
    setChallenge(generateChallenge());
    setUserAnswer("");
    setVerified(false);
    setError("");
  }, []);

  useEffect(() => {
    if (userAnswer && parseInt(userAnswer, 10) === challenge.answer) {
      setVerified(true);
      setError("");
    } else {
      setVerified(false);
    }
  }, [userAnswer, challenge.answer]);

  const validate = useCallback(() => {
    if (parseInt(userAnswer, 10) !== challenge.answer) {
      setError("Incorrect answer. Please try again.");
      setChallenge(generateChallenge());
      setUserAnswer("");
      return false;
    }
    return true;
  }, [userAnswer, challenge.answer]);

  return { challenge, userAnswer, setUserAnswer, verified, error, validate, refresh };
}
